import { Text } from "@clipboard-health/ui-components";
import { Box, Stack } from "@mui/material";

import { ListLoadingState } from "../../redesign/components/ListLoadingState";
import { TextButton } from "../../redesign/components/TextButton";
import { type ChatChannel, type ChatChannelCustomTypesFilter } from "../types";
import { ChatListCard } from "./Card";

interface ChatListContentProps {
  channels: ChatChannel[];
  isFetchingChannels: boolean;
  filterType: ChatChannelCustomTypesFilter;
  onFilterTypeChange: (type: ChatChannelCustomTypesFilter) => void;
}

export function ChatListContent(props: ChatListContentProps) {
  const { channels, isFetchingChannels, filterType, onFilterTypeChange } = props;

  if (isFetchingChannels && filterType !== "support") {
    return (
      <ListLoadingState
        texts={[
          "Loading your conversations",
          "Fetching your latest messages",
          "Almost there, getting your chats ready",
          "Preparing your chat list",
          "Just a moment while we load your conversations",
        ]}
        wrapperSx={{
          height: "50vh",
        }}
      />
    );
  }

  return (
    <Stack spacing={3}>
      {filterType !== "support" &&
        (channels.length === 0 ? (
          <Box
            sx={{
              minHeight: "50vh",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Text semibold variant="h5">
              No chats found
            </Text>
          </Box>
        ) : (
          channels.map((channel) => <ChatListCard key={channel.url} channel={channel} />)
        ))}
      {filterType === "support" && (
        <Box
          sx={{
            minHeight: "50vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <TextButton
            size="large"
            onClick={() => {
              onFilterTypeChange("all");
            }}
          >
            See all chats
          </TextButton>
        </Box>
      )}
    </Stack>
  );
}
